import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { BENEFITS } from "@/lib/data";
import { Reveal, Label } from "@/components/Reveal";

// Bento spans for tetris-like layout
const SPANS = [
  "md:col-span-5",
  "md:col-span-4",
  "md:col-span-3",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-12",
];

export default function Benefits() {
  return (
    <section id="benefits" data-testid="benefits" className="relative py-24 md:py-32 bg-[#0A0E14]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Label>03 — Cosa ottieni</Label>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 max-w-3xl">
            Non feature, ma risultati concreti.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
          {BENEFITS.map((b, i) => (
            <motion.div
              key={i}
              data-testid={`benefit-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className={`${SPANS[i]} group relative bg-[#111827] border border-white/10 p-8 hover:border-[#00C8D7]/50 transition-colors ${
                i === 6 ? "flex flex-col md:flex-row md:items-center md:justify-between gap-4" : ""
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="flex h-9 w-9 items-center justify-center bg-[#00C8D7]/10 text-[#00C8D7] border border-[#00C8D7]/30">
                  <Check size={18} />
                </span>
                <span className="font-mono-tech text-xs text-slate-500">0{i + 1}</span>
              </div>
              <div>
                <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight">{b.t}</h3>
                <p className="mt-2 text-slate-400 leading-relaxed">{b.d}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
